export default function mobileMenu() {
    const mainNavNodes = document.querySelectorAll('#Search_nav .btmNav li');
    const secondaryNav = document.querySelector('.hTop .cta');
    const mobileMenu = document.querySelector('.mobileMenu');
    const target = mobileMenu.querySelector('.menuWrap');
    const resetNavigation = mobileMenu.querySelector('.reset-view a');
    const showTabClassName = 'mega-nav-tab-show';
    let mobileNavHTML = '';

    if (!mobileMenu) {
        return;
    }

    mainNavNodes.forEach(node => mobileNavHTML += node.outerHTML);
    target.insertAdjacentHTML('beforeend', mobileNavHTML);
    target.insertAdjacentHTML('afterend', secondaryNav.outerHTML);

    const checkAjaxNavLoaded = setInterval(() => {
        if (!window.megaNavLoaded) {
            return;
        }

        clearInterval(checkAjaxNavLoaded);
        const ctaNav = document.querySelector('.mobileMenu .cta');

        target.querySelectorAll('li.dropdown').forEach((node, index) => {
            const link = node.querySelector('a');
            const relContent = document.querySelector(`.mega-nav-tab-${index}`);

            if (relContent) {
                node.classList.add('has-childlinks');

                target.insertAdjacentHTML('afterend', relContent.outerHTML);

                const relContentClone = mobileMenu.querySelector(
                    `.mega-nav-tab-${index}`
                );

                relContentClone.insertAdjacentHTML('afterbegin', link.outerHTML);

                link.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    [ctaNav, target].forEach(element => element.classList.add('hide'));

                    mobileMenu.classList.add('level-1');
                    relContentClone.classList.add(showTabClassName);
                });
            }
        });

        mobileMenu.querySelectorAll('img[data-src]').forEach(image =>
            image.src = image.getAttribute('data-src')
        );

        resetNavigation.addEventListener('click', () => {
            mobileMenu.querySelector('.menuContent').scrollTo(0, 0);
            [ctaNav, target].forEach(element => element.classList.remove('hide'));
            mobileMenu.classList.remove('level-1');
            mobileMenu.querySelectorAll('.mega-nav-tab').forEach(node =>
                node.classList.remove(showTabClassName)
            );
        });
    }, 100);
}
// Removing Mega menu off-screen keyboard focus
document.addEventListener('DOMContentLoaded', function() {
    const container = document.querySelector('.mobileMenu');

    if (!container) {
        return;
    }
    function updateMenuFocus() {
        const links = container.querySelectorAll('a[href]');
        if (container.classList.contains('open')) {
            links.forEach((link) => {
                link.removeAttribute('tabindex');
                link.removeAttribute('aria-hidden');
            });
        } else {
            links.forEach((link) => {
                link.setAttribute('tabindex', '-1');
                link.setAttribute('aria-hidden', 'true');
            });
        }
    }
    updateMenuFocus();
    const observer = new MutationObserver(updateMenuFocus);
    observer.observe(container, {
        attributes: true,
        attributeFilter: ['class']
    });
});
// Keyboard focus to search element
(() => {
    const menu = document.querySelector('.menuSearch');
    const btn = document.querySelector('#SearchMobile[data-search-button]');
    const input = document.getElementById('searchText');
    if (!menu || !btn || !input) {
        return;
    }
    const isOpen = () => menu.classList.contains('active');
    const focusNext = () => requestAnimationFrame(() => (isOpen() ? input : btn).focus());

    btn.addEventListener('keydown', (e) => {
        if (e.key === ' ') {
            e.preventDefault(), btn.click();
        }
    });
    btn.addEventListener('click', (e) => {
        e.preventDefault(); focusNext();
    });
    // requestAnimationFrame(() => (isOpen() ? input : btn).focus());
})();
